import { render, staticRenderFns } from "./VotingResult.vue?vue&type=template&id=b289ff2c&scoped=true"
import script from "./VotingResult.vue?vue&type=script&lang=js"
export * from "./VotingResult.vue?vue&type=script&lang=js"
import style0 from "./VotingResult.vue?vue&type=style&index=0&id=b289ff2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b289ff2c",
  null
  
)

export default component.exports